export default __webpack_public_path__ + "static/media/5714.50c6eb5a.png";